import { cva } from 'class-variance-authority';

export const inputWrapperVariants = cva(
  'inline-flex w-full gap-2 items-center justify-start whitespace-nowrap transition-colors group/input text-text-2 border',
  {
    variants: {
      variant: {
        fill: 'rounded-[32px] border-transparent bg-background-6',
        line: 'border-b border-border-5',
        box: 'rounded-[32px] border-border-5',
        ghost: 'border-0 bg-transparent',
      },
      inputSize: {
        small: 'py-[6px] px-3',
        normal: 'py-[10px] px-3',
        large: 'py-[10px] px-3',
        unpadded: 'py-0 px-0',
      },
      isError: {
        true: 'border-error!',
      },
    },
    compoundVariants: [
      {
        variant: 'line',
        class: 'pl-0',
      },
    ],
    defaultVariants: {
      variant: 'fill',
      inputSize: 'normal',
      isError: false,
    },
  }
);

export const inputVariants = cva(
  'text-ellipsis placeholder:text-text-5 w-full focus-within:placeholder:text-text-2 group-hover/input:placeholder:text-text-3 group-hover/input:disabled:cursor-not-allowed group-hover/input:disabled:placeholder:text-text-5 read-only:select-none read-only:cursor-not-allowed',
  {
    variants: {
      inputSize: {
        small: 'text-input-text-sm',
        normal: 'text-input-text-md',
        large: 'text-input-text-lg',
        unpadded: 'text-input-text-md',
      },
    },
    defaultVariants: {
      inputSize: 'normal',
    },
  }
);
